module.exports = {
   name: 'Client Type',
   gen_template: `
      {
         "coa": "ASSET",
         "code": "{{random.alphaNumeric}}{{random.number}}{{random.alphaNumeric}}{{random.number}}", 
         "name": "{{lorem.word}}"
      }
   `,
   wizard: {
      actionBtn: 'Save',
      action: 'add_client_type',
      pages: [
         {
            title: 'Client Type',
            subtitle: 'Configure new client types',
            forms: [
               {
                  type: 'image', class: 'col-12 col-md-12 ', model: 'icon',
                  imageFormat: 'png', validation: 'required', label: 'Icon'
               },
               {
                  type: 'text', form_type: 'text', label: 'Code', model: 'type_code',
                  validation: 'required|min:1|max:50', class: 'col-12 col-md-6'
               },
               {
                  type: 'text', form_type: 'text', label: 'Name', model: 'type_name',
                  validation: 'required|min:3|max:150', class: 'col-12 col-md-6'
               },
               {
                  type: 'textarea', form_type: 'text', label: 'Description', model: 'type_description',
                  validation: 'required|min:10|max:500', class: 'col-12'
               },
            ],
         }
      ]
   },
   table: {
      title: 'Client Type',
      subtitle: 'A list of configured insurance client types',
      table_fields: [
  
         { name: 'Code', align: 'l' },
         { name: 'Name', align: 'l' },
         { name: 'Description', align: 'l' },  
         { name: 'actions', align: 'c' }
      ],
      searchFields: ["code", "name", "min_account_bal", "max_account_bal"],
      rowData: [

         { type: 'text', field: 'type_code', class: 'left bolder' },
         { type: 'text', field: 'type_name', class: 'left bolder small' },
         { type: 'text', field: 'type_description', class: 'left bolder' },
         {
            type: 'action', field: 'name', class: 'center', icon: '', actions: [
               // {type: 'title', title: 'Actions'},
            
               {
                  type: 'menu', title: 'View', event: 'client:view', icon: 'ico-reply', params: [
                     { key: 'client_type', field: '*' }
                  ]
               },
               {
                  type: 'menu', title: 'Edit', event: 'client:edit', icon: 'ico-reply', params: [
                     { key: 'client_type', field: '*' }
                  ]
               },
               
              
            ]
         },
      ]
   },
}